module.exports = __webpack_public_path__ + "static/certificates-908d0e893e137bc9d894dca82f23f126.svg";